import React from 'react';
import { Text, TextVariant } from '@naf/text';
import { useResolvedNavigationLink } from '../../../hooks/useResolvedNavigationLink';
import { LinkListItem } from '../../../../../types/globalSettingsType';
import { useHandleNavigationClick } from '../../../utils/Tracking/Navigation/NavigationTracking';
import { AppLink } from '../../AppLink/AppLink';

interface MenuLinkListProps {
  link?: LinkListItem | null;
  megaMenuSectionName?: string;
}

// Links in list below section header.
export const MenuLinkList = ({ link, megaMenuSectionName }: MenuLinkListProps) => {
  const { url, blank } = useResolvedNavigationLink({
    data: link?.reference,
    type: link?.type,
    href: link?.href,
    blank: link?.blank,
    slug: link?.slug,
  });

  const handleOnClick = useHandleNavigationClick({
    event: 'megaMenuClick',
    menuSectionName: megaMenuSectionName,
    menuItemName: link?.title ?? '',
    menuItemUrl: url,
  });

  if (!link?.title || !url) return null;

  return (
    <li key={link.key}>
      <Text tag="span" variant={TextVariant.BodyText}>
        <AppLink url={url} blank={blank} onClick={handleOnClick}>
          {link.title}
        </AppLink>
      </Text>
    </li>
  );
};
